import React from "react";
import { Layout } from "@evertrue/et-components";

import { NxtIntegration } from "apps/integrations/crm/integration-cards/nxt-integration";

// TODO: Add content card dynamic layout(pending further integrations of this type.)
const CrmController = () => {
  return (
    <React.Fragment>
      <Layout headerBorder={false}>
        <NxtIntegration />
      </Layout>
    </React.Fragment>
  );
};

export default CrmController;
